<template>
  <v-alert :type="type" :icon="_icon" border="left" text>
    <slot />
  </v-alert>
</template>
<script>
export default {
  name: 'Alert',
  props: {
    icon: { type: String },
    type: { type: String },
  },
  computed: {
    _icon() {
      switch (this.type) {
        case 'success': {
          return 'mdi-check-circle-outline'
        }
        case 'warning': {
          return 'mdi-alert-box-outline'
        }
        case 'error': {
          return 'mdi-alert-circle-outline'
        }
        case 'info': {
          return 'mdi-information-variant-circle-outline'
        }
        default:
          return this.icon
      }
    },
    _color() {
      switch (this.type) {
        case 'success': {
          return 'green'
        }
        case 'warning': {
          return 'orange'
        }
        case 'error': {
          return 'red'
        }
        default:
          return 'blue'
      }
    },
  },
}
</script>
